/**
 * Users API (admin only)
 */

import { apiClient } from "./apiClient";

export const usersAPI = {
  list: (params = {}) => apiClient.get("/auth/users/", { params }),
  get: (userId) => apiClient.get(`/auth/users/${userId}/`),
  create: (payload) => apiClient.post("/auth/users/", payload),
  update: (userId, payload) =>
    apiClient.patch(`/auth/users/${userId}/`, payload),
  remove: (userId) => apiClient.delete(`/auth/users/${userId}/`),
  // Self-update endpoint (any authenticated user can update their own profile)
  updateMe: (payload) => apiClient.patch("/auth/me/", payload),
  // Admin-only helpers
  sendClientResetLink: (userId) =>
    apiClient.post(`/auth/users/${userId}/send-reset-link/`),
  setAnalystPassword: (userId, payload) =>
    apiClient.post(`/auth/users/${userId}/set-analyst-password/`, payload),
};
